<template>
  <el-row :gutter="20">
    <el-col :span="6">
      <menu-column :list="list.menu"></menu-column>
      <!-- <news-list></news-list> -->
    </el-col>
    <el-col :span="18">
      <nav-bar :list="list.nav"></nav-bar>
      <div class="main">
        <div class="main-context">

           <template v-if="$route.params.portId==='port07'">
             <el-row :gutter="12">
               <el-col :span="12"  v-for="(item,index) in list.data" :key="index">
                 <column-basic border :list="item">
                      <list-simple style="min-height:208px;margin-top:12px;" :list="item.dt"></list-simple>
                  </column-basic>
               </el-col>
             </el-row>
            
          </template>


          <template v-else-if="list.model=='-1'||list.model=='-2'">
            <column-basic border v-for="(item,index) in list.data" :key="index" :list="item">
              <template v-if="item.type_model==1">
                <list-image :list="item.dt"></list-image>
              </template>

              <template v-else-if="item.type_model==2">
                <ArticleDetail :art="item.dt[0]"></ArticleDetail>
              </template>
              <template v-else>
                <list-thum :list="item.dt"></list-thum>
              </template>
            </column-basic>
          </template>

          <template v-else-if="list.model=='0'">
            <!-- 我的图文列表 -->
            <column-basic border :list="list.nav[list.nav.length-2]">
              <list-thum :list="list.data.dt">
              </list-thum>
            </column-basic>
          </template>
          <template v-else-if="list.model=='1'">
            <!-- 我的图片列表 -->
            <column-basic border :list="list.nav[list.nav.length-2]">
              <list-image :list="list.data.dt">
              </list-image>
            </column-basic>
          </template>
          <template v-else-if="list.model=='2'">
            <!-- 我是内容模式 -->
            <ArticleDetail :art="list.data"></ArticleDetail>
          </template>


          <el-pagination v-if="['0','1'].indexOf(list.model)!=-1" class="am-margin-vertical-sm am-text-right"
            @current-change="currentChange" :current-page.sync="currentPage" :page-size="20"
            layout="total, prev, pager, next" :total="list.data.countRow">
          </el-pagination>


        </div>
      </div>


    </el-col>
  </el-row>

</template>

<script>
  import {
    listModel,
    listPage,
    listSearch
  } from '@/api/list'
  import NewsList from '@/components/basic/NewsList'
  import NavBar from '@/components/basic/NavBar'
  import ArticleDetail from '@/components/article'
  import MenuColumn from '@/components/basic/MenuColumn'
  import ColumnBasic from '@/components/column/ColumnBasic'
  import ListSimple from '@/components/list/ListSimple2'
  
  import ListThum from '@/components/list/ListThum'
  import ListImage from '@/components/list/ListImage'
  export default {
    components: {
      NavBar,
      MenuColumn,
      ColumnBasic,
      ListThum,ListSimple,
      ListImage,
      ArticleDetail,
      NewsList
    },
    data() {
      return {
        list: {
          menu: {
            parent: {},
            child: []
          }
        },
        menu: {},
        total: 0,
        currentPage: 1
      }
    },
    computed: {
      navListString() {
        const list = this.list.nav.map(e => {
          return e.type_name
        })
        return list.join(' > ')

      }
    },
    methods: {
      currentChange(currentPage) {
        listPage(this.$route.params.portId, currentPage).then(result => {
          this.list.data = result
          scrollTo(0, 0)
        })
      },
      showLoad() {
        return this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        const loading = vm.showLoad()
        listModel(to.params.portId).then(result => {
          loading.close();
          vm.list = result
          vm.list.nav.push({
            type_name: '列表详情'
          })
          document.title = vm.list.menu.parent.type_name
        })
        setTimeout(() => {
          loading.close();
        }, 8000);
      })
    },
    beforeRouteUpdate(to, from, next) {
      const loading = this.showLoad()
      this.total = 0,
        this.currentPage = 1
      listModel(to.params.portId).then(result => {
        loading.close();
        this.list = result
        this.list.nav.push({
          type_name: '列表详情'
        })
        document.title = this.list.menu.parent.type_name
      })
      setTimeout(() => {
        loading.close();
      }, 8000);
      next()
    }
  }
</script>